<template>
  <ion-router-outlet id="blank" />
</template>
